<template>
  <div
    v-if="show"
    :class="$style.bottom_banner"
    :style="{ ...blackFridayBannerStyles }"
  >
    <div
      :class="$style.banner"
      :style="{ backgroundImage: 'url(https://cdn.ganttpro.com/app/imgs/pricing/BF_bottom_banner.png)' }"
    >
      <div
        :class="$style.wrapper"
        @click="onClickToBilling"
      >
        <div :class="$style.left_side">
          Black Weeks
        </div>
        <div :class="$style.right_side">
          <div :class="$style.text">
            {{ locales('bf_top_banner_description') }}
          </div>
          <fridayButton
            :readonly="true"
            :bold="true"
            :styles="{fontSize: '14px', lineHeight: '20px'}"
            :text="locales('bf_banner_period')"
            :style="{marginRight: '72px'}"
          />
          <fridayButton
            :small="false"
            :style="{marginRight: '72px'}"
          />
        </div>
      </div>
      <icon-button
        :icon="{ name: 'close-1' }"
        :colors="buttonColors"
        :style="{
          position: 'absolute',
          right: '16px',
          top: '50%',
          transform: 'translateY(-50%)',
        }"
        @onClick="onCloseClick"
      />
    </div>
  </div>
</template>

<script>
import fridayButton from './BFButton.vue';
import iconButton from '../../../common/VueComponents/globalButton/withIcon/iconButton.vue';
import plansModel from '../../../../models/plans';
import rights from '../../../../components/rights/index';
import routerHelper from '../../../../helpers/router';

export default {
  components: { fridayButton, iconButton },
  emits: { onClose: null },
  data() {
    return {
      locales: __,
      buttonColors: {
        color: '#fff',
        hoverBg: '#333333',
      },
      isShowBanner: true,
    };
  },
  computed: {
    accessToBiling() {
      const planName = plansModel.getPlanName();
      const isTrial = plansModel.isTrial();
      const isAccountOwner = rights.account.isOwner();
      const isEnterpriseTeamPlan = plansModel.isEnterpriseTeamPlan() || planName === 'enterprise';

      return (isTrial || isAccountOwner) && !isEnterpriseTeamPlan;
    },
    uiConfig() {
      return this.$store.getters['footer/UIConfig'];
    },
    leftSidebarWidth() {
      return this.$store.getters.leftSidebarWidth;
    },
    blackFridayBannerStyles() {
      return {
        bottom: this.uiConfig && this.uiConfig.existFooter ? '30px' : '0',
        left: `${this.leftSidebarWidth}px`,
        width: `calc(100% - ${this.leftSidebarWidth}px)`,
      };
    },
    show() {
      return this.isShowBanner && this.accessToBiling;
    },
    width() {
      const documentWidth = document.documentElement.clientWidth;
      const width = documentWidth - this.leftSidebarWidth;

      return `${width}px`;
    },
  },
  created() {
    if ('bottomBlackFridayBanner' in localStorage) {
      const value = JSON.parse(localStorage.getItem('bottomBlackFridayBanner'));

      this.isShowBanner = value;
    } else {
      this.isShowBanner = true;
    }
  },
  methods: {
    onClickToBilling() {
      const currentRoute = routerHelper.getCurrentRoute();
      const isTrial = plansModel.isTrial();
      const isActive = plansModel.isActiveSubscription();

      if (isActive && isTrial) {
        this.$store.commit('paymentClient/showPaymentPage', true, { root: true });

        return;
      }

      if (currentRoute?.name !== 'billing') {
        routerHelper.pushRoute({
          name: 'billing',
        });
      }
    },
    onCloseClick() {
      localStorage.setItem('bottomBlackFridayBanner', JSON.stringify(false));
      this.isShowBanner = false;
    },
  },
};
</script>

<style module lang="less">
@import '../../../../less/_mixins.less';
@import '../../../../less/_fonts.less';
@import '../../../../less/_variables.less';

 .bottom_banner {
  position: fixed;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
  background: #111416;

  .banner {
    // max-width: 1660px;
    // width: 1660px;
    // min-width: 1660px;
    width: 100%;
    height: 54px;
    display: flex;
    justify-content: center;
    background-size: cover;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 16px 0 100px;
    cursor: pointer;

    .left_side {
      .FontLatoBold;
      font-size: 36px;
      font-style: normal;
      line-height: 44px; /* 117.647% */
      white-space: nowrap;

      background: linear-gradient(94deg, rgba(153, 187, 183, 0.10) -19.88%, #FFF 48.68%, rgba(255, 255, 255, 0.63) 117.23%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .right_side {
      display: flex;
      align-items: center;

      .text {
        .FontLatoBold;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        line-height: 28px; /* 114.286% */

        background: linear-gradient(269deg, #FFF 0.4%, rgba(255, 255, 255, 0.40) 132.12%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        margin-right: 24px;
      }
    }
  }
 }
</style>
